import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "@i18n";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { qs } from "url-parse";
import Layout from "@/_LayoutsRelated/layout/Layout";
import Button from "../../components/UiKit/Button/Button";
import Disclaimer from "@/_MiniApps/Disclaimer/Disclaimer";
import stl from "./PreCheckout.module.css";
import { cashCheckout1Event, finanaceButtonClickedEvents } from "@/utils/dataLayerEvents";
import PaymentInfo from "@/pages/checkout/PaymentInfo/PaymentInfo";
import CampaignModal from "@/pages/checkout/CampaignModal/CampaignModal";
import { trackEvents } from "@/common/events/events";
import { useIsMobile } from "@/common/Contexts/IsMobileContext";
import CancelButton from "../../components/UiKit/Buttons/CancelButton/CancelButton";
import PreCheckoutMainForm from "@/pages/pre-checkout/components/PreCheckoutMainForm/PreCheckoutMainForm";
import useHelpers from "@hooks/useHelpers";
import { api__getOrderWithPaymentInfo } from "@/apis/orders/orders";
import useApi from "@hooks/useApi";
import Loader from "@/components/sharedComponents/Loader";
var PreCheckout = function PreCheckout() {
  var _checkoutOrder$campai, _checkoutOrder$campai2;
  if (__IS_SSR__) return /*#__PURE__*/React.createElement(Loader, null);
  // const checkoutData = useSelector((state) => state.checkout);
  var location = useLocation();
  var queryParams = new URLSearchParams(location.search);
  var freefinance = queryParams.get("freefinance");
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isMobile = useIsMobile();
  var _useParams = useParams(),
    postId = _useParams.postId;
  var _useApi = useApi([postId], function () {
      return api__getOrderWithPaymentInfo(null, postId);
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    checkoutOrder = _useApi2[2];
  var _useState = useState(null),
    value = _useState[0],
    setValue = _useState[1];
  var _useState2 = useState(null),
    event = _useState2[0],
    setEvent = _useState2[1];
  var _useState3 = useState(null),
    financeValue = _useState3[0],
    setFinanceValue = _useState3[1];
  var _useState4 = useState(null),
    showCampaignModal = _useState4[0],
    setShowCampaignModal = _useState4[1];
  var navigate = useNavigate();
  var handleChange = function handleChange(e) {
    setValue(e.target.value);
  };
  var handleContinue = function handleContinue() {
    if (!value) return;
    if (+value === 1) return navigateTo("/checkout/shop-apply?postId=".concat(postId));
    if (+financeValue === 2) return navigateTo("/finance-apply/".concat(postId));
    if (+value === 2) return navigateTo("/finance-apply/".concat(postId));
    if (+value === 3) return navigateTo("/finance-apply-free/".concat(postId, "?").concat(qs.stringify({
      financestep: 1
    })));
  };
  if (loading) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(Layout, {
    hideBurgerMenu: isMobile,
    hideFooter: true,
    hideOrangeHeadBtn: true,
    headHideLinks: true,
    hideAppBanner: true,
    straightHeader: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement("div", {
      className: stl.mobileHeader
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("strong", null, t("كاش ام تمويل", {
      ns: "web_pre_checkout"
    })), /*#__PURE__*/React.createElement(CancelButton, {
      isArrow: true,
      onClick: function onClick() {
        // navigateTo(`/cardetail/${postId}`);
        navigate(-1);
      },
      className: "".concat(stl.CancelButton)
    })))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.container, " container")
  }, /*#__PURE__*/React.createElement("div", {
    className: ["m-show", stl.mobileCarName].join(" ")
  }, /*#__PURE__*/React.createElement("strong", null, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_title), /*#__PURE__*/React.createElement("strong", null, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_price, /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_common"
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.flxContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.subBox
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.newContDesign
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.title
  }, t("اختر الطريقة المناسبة لشراء هذه السيارة؟", {
    ns: "web_pre_checkout"
  })), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PreCheckoutMainForm, {
    checkoutOrder: checkoutOrder,
    setShowCampaignModal: setShowCampaignModal,
    handleChange: handleChange,
    setEvent: setEvent,
    value: value
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      var _checkoutOrder$g4_dat, _checkoutOrder$g4_dat2;
      handleContinue();
      trackEvents("checkout", _objectSpread(_objectSpread({}, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer), {}, {
        booking_type: event,
        post_trim: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat === void 0 ? void 0 : _checkoutOrder$g4_dat.post_ext,
        from_finance_calculator: false,
        inventory_type_string: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat2 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat2 === void 0 ? void 0 : _checkoutOrder$g4_dat2.inventory_type_string
        // filters,
      }));
      if (event === "finance") {
        finanaceButtonClickedEvents(null, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data);
      } else {
        cashCheckout1Event("checkout_lead", checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data);
      }
    },
    className: stl.btn,
    isDisabled: !value
  }, t("متابعة", {
    ns: "web_common"
  }))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "m-show"
  }, /*#__PURE__*/React.createElement(Disclaimer, {
    className: stl.Disclaimer
  }))), /*#__PURE__*/React.createElement("div", {
    className: [stl.subBox2, "m-hide"].join(" ")
  }, /*#__PURE__*/React.createElement(PaymentInfo, {
    checkoutOrder: checkoutOrder
  })))), showCampaignModal && /*#__PURE__*/React.createElement(CampaignModal, {
    modalName: showCampaignModal,
    doClose: function doClose() {
      return setShowCampaignModal(null);
    },
    campaignData: showCampaignModal === "finance" ? checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$campai = checkoutOrder.campaigns) === null || _checkoutOrder$campai === void 0 ? void 0 : _checkoutOrder$campai.finance : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$campai2 = checkoutOrder.campaigns) === null || _checkoutOrder$campai2 === void 0 ? void 0 : _checkoutOrder$campai2.cash
  }));
};
export default PreCheckout;